import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import TextareaAutosize from 'react-autosize-textarea';
import CompanyRegistrationDropdown from '../CompanyRegistrationDropdown';
import './PastRoleForm.scss';

const months = [
  { label: 'January', value: '0' },
  { label: 'February', value: '1' },
  { label: 'March', value: '2' },
  { label: 'April', value: '3' },
  { label: 'May', value: '4' },
  { label: 'June', value: '5' },
  { label: 'July', value: '6' },
  { label: 'August', value: '7' },
  { label: 'September', value: '8' },
  { label: 'October', value: '9' },
  { label: 'November', value: '10' },
  { label: 'December', value: '11' },
];

const years = () => {
  let currentYear = new Date().getFullYear();
  const yearsArray = [{ label: currentYear, value: currentYear }];
  const endDate = currentYear - 80;
  while (currentYear > endDate) {
    currentYear -= 1;
    yearsArray.push({ label: currentYear, value: currentYear });
  }
  return yearsArray;
};

const renderErrorMessage = (error) => {
  let invalidEndDate = '';
  if (error.includes('The end date must be after the start date.')) {
    invalidEndDate = error.pop().toString();
    error.pop();
  }
  const { length } = error;
  return (
    <div className="error-message">
      <i className="fa fa-exclamation-triangle" />
      {error.length > 0 && `Please enter ${error.slice(0, length - 1).join(', ')} ${length > 1 ? 'and' : ''} ${error.slice(-1)}. `}
      {invalidEndDate}
    </div>
  );
};

const handleChange = (handleInputChange, event, index) => {
  const { target } = event;
  const value = target.type === 'checkbox' ? target.checked : target.value;
  handleInputChange(value, target.name, index);
};

const handleSelectChange = (handleDateChange, name, event, index) => {
  handleDateChange(event, name, index);
};

function PastRoleForm({
  index,
  classNamePrefix,
  pastRole,
  handleInputChange,
  handleDateChange,
  handleDeletePastRole,
  error,
  onProposalPage,
  onboardingQuestionnaire,
}) {
  const dropdownStyle = {};
  return (
    <div className={`past-role-form ${onboardingQuestionnaire && 'border-padding'}`}>
      <div className="past-roles-input-field">
        <label htmlFor="title">Title</label>
        <input
          className={`input-base ${classNamePrefix}-title ${error && error.includes('title') && 'error'}`}
          type="text"
          name="title"
          placeholder="e.g. Senior Manager, Clinical Data Management"
          value={pastRole.title}
          onChange={(e) => handleChange(handleInputChange, e, index)}
          required
        />
      </div>
      <div className="past-roles-input-field">
        <label htmlFor="company_name">Company name</label>
        <CompanyRegistrationDropdown
          className={`input-base ${classNamePrefix}-company-name`}
          error={error && error.includes('company name') ? 'Please enter company name.' : null}
          value={pastRole.companyName}
          onChange={(data) => handleInputChange(data.value, 'companyName', index)}
        />
      </div>
      <div className="month-year-inputs-container">
        <label htmlFor="start_date">Start date</label>
        <div className="month-year-inputs">
          <Select
            components={dropdownStyle}
            className={`${classNamePrefix}-start-month start-date-month`}
            classNamePrefix="react-select"
            options={months}
            value={pastRole.startDateMonth}
            maxMenuHeight={500}
            placeholder="Select month"
            onChange={(e) => handleSelectChange(handleDateChange, 'startDateMonth', e, index)}
          />
          <Select
            components={dropdownStyle}
            className={`${classNamePrefix}-start-year start-date-year`}
            classNamePrefix={`${(error && error.includes('start date')) ? 'select-error' : 'react-select'}`}
            options={years()}
            value={pastRole.startDateYear}
            maxMenuHeight={500}
            placeholder="Select year"
            onChange={(e) => handleSelectChange(handleDateChange, 'startDateYear', e, index)}
          />
        </div>
      </div>
      <div className="month-year-inputs-container">
        { !pastRole.current && <label htmlFor="end_date">End date</label> }
        <div className="month-year-inputs" d>
          { pastRole.current
            ? <div className="">Present</div>
            : (
              <Fragment>
                <Select
                  components={dropdownStyle}
                  className={`${classNamePrefix}-end-month end-date-month`}
                  classNamePrefix="react-select"
                  options={months}
                  value={pastRole.endDateMonth}
                  maxMenuHeight={500}
                  placeholder="Select month"
                  onChange={(e) => handleSelectChange(handleDateChange, 'endDateMonth', e, index)}
                />
                <Select
                  components={dropdownStyle}
                  className={`${classNamePrefix}-end-year end-date-year`}
                  classNamePrefix={`${(error && error.includes('end date')) ? 'select-error' : 'react-select'}`}
                  options={years()}
                  value={pastRole.endDateYear}
                  maxMenuHeight={500}
                  placeholder="Select year"
                  onChange={(e) => handleSelectChange(handleDateChange, 'endDateYear', e, index)}
                />
              </Fragment>
            )}
        </div>
      </div>
      <div className="input-field mb-2">
        <input
          type="checkbox"
          name="current"
          className={`${classNamePrefix}-current`}
          checked={pastRole.current}
          onChange={(e) => handleChange(handleInputChange, e, index)}
        />
          &nbsp;&nbsp;I currently work here
      </div>
      {!onProposalPage
      && (
      <div className="past-roles-input-field">
        <label htmlFor="description">Description</label>
        <TextareaAutosize
          className={`input-base ${classNamePrefix}-description ${error && error.includes('description') && 'error'}`}
          placeholder="Describe your role a bit more."
          rows={3}
          value={pastRole.description}
          name="description"
          onChange={(e) => handleChange(handleInputChange, e, index)}
          required
        />
      </div>
      )}
      {error.length > 0 && renderErrorMessage(error)}
      <div className="delete-past-role-container">
        { handleDeletePastRole
          && (
          <div className="delete-past-role">
            <a
              role="button"
              tabIndex={0}
              type="button"
              id="delete-past-role"
              onClick={() => handleDeletePastRole(index)}
            >
              <i className="fa fa-trash-alt" />
            </a>
          </div>
          )}
      </div>
    </div>
  );
}

PastRoleForm.propTypes = {
  index: PropTypes.number,
  classNamePrefix: PropTypes.string,
  pastRole: PropTypes.shape({}).isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleDateChange: PropTypes.func.isRequired,
  handleDeletePastRole: PropTypes.func,
  error: PropTypes.arrayOf(PropTypes.string),
  onProposalPage: PropTypes.bool,
  onboardingQuestionnaire: PropTypes.bool,
};

PastRoleForm.defaultProps = {
  index: null,
  classNamePrefix: '',
  error: [],
  handleDeletePastRole: null,
  onProposalPage: false,
  onboardingQuestionnaire: false,
};

export default PastRoleForm;
